// extracted by mini-css-extract-plugin
export default {"timer":"Timer_timer__uCnRw","countdown":"Timer_countdown__PcfEs","buttons":"Timer_buttons__KatKn"};